"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import t from "../components/Icon/SvgIcon.js";
const r = (e) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.744 2.131a.875.875 0 0 1 0 1.238L7.112 12l8.632 8.631a.875.875 0 1 1-1.238 1.238l-9.243-9.243a.885.885 0 0 1 0-1.252l9.243-9.243a.875.875 0 0 1 1.238 0",
        clipRule: "evenodd"
      }
    )
  }
), f = l(r);
export {
  f as ChevronLeft,
  f as default
};
